import serviceTwo from './serviceTwo';

export const customRolesListing = async (payload) => {
  const response = await serviceTwo.postTwo(`/custom-roles/list`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const createCustomRole = async (payload) => {
  const response = await serviceTwo.postTwo(`/custom-roles/create`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const updateCustomRole = async (payload) => {
  const response = await serviceTwo.postTwo(`/custom-roles/update`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};

export const toggleCustomRole = async (payload) => {
  const response = await serviceTwo.postTwo(`/custom-roles/toggle-role-activity`, payload);

  if (response.status === 200) {
    const data = response.data;

    return data;
  }

  return undefined;
};
